// extracted by mini-css-extract-plugin
export var cardSelected = "_gc-2";
export var image = "_gc-1";
export var table = "_gc-0";